(function() {
  'use strict';

  function initLpOurCreators(section) {
    if (!section?.dataset.sectionId) return;

    const sectionId = section.dataset.sectionId;
    const swiperEl = section.querySelector(`.lp-our-creators-${sectionId}`);
    if (!swiperEl || typeof Swiper === 'undefined') return;

    // Check if already initialized
    if (swiperEl.swiper) return;

    new Swiper(swiperEl, {
      slidesPerView: 2,
      spaceBetween: 12,
      loop: true,
      centeredSlides: true,
      breakpoints: {
        750: {
          slidesPerView: 3,
          spaceBetween: 16,
        }
      }
    });
  }

  // Initialize sections
  const initSections = () => {
    document.querySelectorAll('.lp-our-creators[data-section-id]').forEach(initLpOurCreators);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSections);
  } else {
    initSections();
  }

  // Re-initialize on section load (for theme editor)
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.detail.querySelector('.lp-our-creators');
    if (section) {
      // Destroy existing Swiper if it exists
      const swiperEl = section.querySelector('.lp-our-creators__swiper');
      if (swiperEl?.swiper) {
        swiperEl.swiper.destroy(true, true);
      }
      initLpOurCreators(section);
    }
  });
})();

